import { gql } from '@apollo/client';

export const GET_ORGANISATION_ADD_ONS = gql`
  query GetOrganisationAddOns($input: OrganisationAddOnsInput!) {
    addOns: getOrganisationAddOns(input: $input) {
      id
      name
    }
  }
`;
